export default __webpack_public_path__ + "static/media/info.3e7741bf.svg";